// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import {
  convertToCustomer,
  createContact,
  deleteContact,
  getContactDetail,
  getContactList,
  sendEmail,
  updateContact,
} from './contactThunk';

export interface IContactState {
  isRefreshContactList: boolean;
}

export const initialState: IContactState = {
  isRefreshContactList: false,
};

const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    setRefreshContactList: (state, action) => {
      state.isRefreshContactList = action.payload;
    },
  },
  extraReducers: (builder) => {
    // POST: Create contact
    builder
      .addCase(createContact.pending, (_state) => {})
      .addCase(createContact.fulfilled, (_state) => {})
      .addCase(createContact.rejected, (_state) => {});

    // GET: Get contact list
    builder
      .addCase(getContactList.pending, (_state) => {})
      .addCase(getContactList.fulfilled, (_state) => {})
      .addCase(getContactList.rejected, (_state) => {});

    // GET: Get detail contact
    builder
      .addCase(getContactDetail.pending, (_state) => {})
      .addCase(getContactDetail.fulfilled, (_state) => {})
      .addCase(getContactDetail.rejected, (_state) => {});

    // PUT: Update contact
    builder
      .addCase(updateContact.pending, (_state) => {})
      .addCase(updateContact.fulfilled, (_state) => {})
      .addCase(updateContact.rejected, (_state) => {});

    // POST: Send email
    builder
      .addCase(sendEmail.pending, (_state) => {})
      .addCase(sendEmail.fulfilled, (_state) => {})
      .addCase(sendEmail.rejected, (_state) => {});

    // PUT: Convert to customer
    builder
      .addCase(convertToCustomer.pending, (_state) => {})
      .addCase(convertToCustomer.fulfilled, (_state) => {})
      .addCase(convertToCustomer.rejected, (_state) => {});

    // DELETE: Delete contact
    builder
      .addCase(deleteContact.pending, (_state) => {})
      .addCase(deleteContact.fulfilled, (_state) => {})
      .addCase(deleteContact.rejected, (_state) => {});
  },
});

// Action
export const contactActions = contactSlice.actions;

// Selectors
export const selectIsRefreshContactList = (state: RootState) => state.contact.isRefreshContactList;

// Reducer
const contactReducer = contactSlice.reducer;
export default contactReducer;
